export default "__VITE_ASSET__N8VQ5o52__"